import SEOHead, { SITE_URL } from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import QuoteCards from './components/QuoteCards';
import AboutSection from './components/AboutSection';
import InsuranceCards from './components/InsuranceCards';
import AgencyAdvantage from './components/AgencyAdvantage';
import ManagePolicies from './components/ManagePolicies';
import Reviews from './components/Reviews';
import HomeContactForm from './components/HomeContactForm';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'InsuranceAgency',
    name: 'White Oak Insurance Group',
    description:
      'White Oak Insurance Group is a licensed independent insurance agency in Hattiesburg, MS, offering personal, business, and industry insurance solutions.',
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.ico`,
    image:
      'https://storage.readdy-site.link/project_files/5a4bdf41-1aeb-4fa9-8af1-697cd10aa572/f860084d-aa32-4e78-b420-78d05d635e90_Pro-Headshot.jpg',
    telephone: '+1-601-325-9000',
    email: 'cameron@whiteoakig.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '406 Hemphill St',
      addressLocality: 'Hattiesburg',
      addressRegion: 'MS',
      postalCode: '39401',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 31.3271,
      longitude: -89.2903,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '17:00',
      },
    ],
    areaServed: {
      '@type': 'State',
      name: 'Mississippi',
    },
    priceRange: '$$',
    sameAs: ['https://www.facebook.com', 'https://www.linkedin.com'],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'White Oak Insurance Group',
    url: SITE_URL,
    description:
      'Independent insurance agency in Hattiesburg, MS providing personal, business, and industry insurance coverage.',
    publisher: {
      '@type': 'Organization',
      name: 'White Oak Insurance Group',
    },
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="White Oak Insurance Group | Hattiesburg, MS Independent Insurance Agency"
        description="White Oak Insurance Group is a licensed independent insurance agency in Hattiesburg, MS. Providing personal, business, and industry insurance solutions. Call 601-325-9000 for a free quote."
        keywords="insurance agency Hattiesburg MS, independent insurance agent, personal insurance Mississippi, business insurance Hattiesburg, White Oak Insurance Group"
        canonical="/"
        ogImage="https://storage.readdy-site.link/project_files/5a4bdf41-1aeb-4fa9-8af1-697cd10aa572/f860084d-aa32-4e78-b420-78d05d635e90_Pro-Headshot.jpg"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <QuoteCards />
        <AboutSection />
        <InsuranceCards />
        <AgencyAdvantage />
        <ManagePolicies />
        <Reviews />
        <HomeContactForm />
      </main>
      <Footer />
    </div>
  );
}
